import { NavTabs } from "src/components/ui/NavTabs";

import { useAppState } from "src/state";

export function SuperAdminTalentTabs({
    overlay = false
}: React.PropsWithChildren<{
    overlay?: boolean
}>): React.ReactElement {

    const { currentItemId } = useAppState(state=>state.users)

    return ( 
        <NavTabs
            overlay={overlay}
            parentId={currentItemId}
            urlRoot='/talent'
            tabs={{
                details: {
                    label: 'Talent Overview',
                    icon: 'home',
                    route: ''
                },
                guidelines: {
                    label: 'Talent Guidelines',
                    icon: 'guideline',
                    route: 'guidelines'
                },
                blackouts: {
                    label: 'Blackout Dates',
                    icon: 'blackout',
                    route: 'blackouts'
                },
                documents: {
                    label: 'Documents',
                    icon: 'files',
                    route: 'documents'
                }
            }}
        />
    )

}